class RecentlyViewedProducts {
    setCurrentHandle() {
      if (!this.currentHandle) return;
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem(this.storageKey)) || [];
      } catch {
        handles = [];
      }
      handles = handles.filter(handle => handle !== this.currentHandle);
      handles.unshift(this.currentHandle);
      handles = handles.slice(0, this.productLimit);
      localStorage.setItem(this.storageKey, JSON.stringify(handles));
    }
  constructor({
    sectionSelector = '[data-recently-viewed]',
    storageKey = 'theme_recently_viewed_product',
    productLimit = 20,
  } = {}) {
    this.sectionSelector = sectionSelector;
    this.storageKey = storageKey;
    this.productLimit = productLimit;

    this.init();
  }

  init() {
    console.log('RecentlyViewedProducts: Initializing with config', {
      sectionSelector: this.sectionSelector,
      storageKey: this.storageKey,
      productLimit: this.productLimit,
    });
    this.section = document.querySelector(this.sectionSelector);
    console.log('RecentlyViewedProducts: Found section', this.section);
    if (!this.section) return;

    this.swiperElement = this.section.querySelector('[data-swiper]');
    this.swiperContainer = this.section.querySelector('[data-swiper-container]');
    console.log('RecentlyViewedProducts: Found swiper element', this.swiperElement);
    console.log('RecentlyViewedProducts: Found swiper container', this.swiperContainer);

    if (!this.swiperContainer) return;

    this.currentHandle = this.section.dataset.currentHandle || null;
    console.log('RecentlyViewedProducts: Current handle', this.currentHandle);  

    this.setCurrentHandle();
    this.render();
  }

  getStoredHandles() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch {
      return [];
    }
  }

  getFilteredHandles(handles) {
    return handles
      .filter(Boolean)
      .filter(handle => handle !== this.currentHandle)
      .slice(0, this.productLimit);
  }

  async render() {
    let handles = this.getStoredHandles();
    handles = this.getFilteredHandles(handles);

    if (!handles.length) {
      this.section.remove();
      return;
    }

    const productCards = await this.fetchProductCards(handles);

    const validCards = productCards.filter(Boolean);

    if (!validCards.length) {
      this.section.remove();
      return;
    }

    this.appendCards(validCards);

    this.finalize();
  }

  async fetchProductCards(handles) {
    const results = await Promise.allSettled(
      handles.map(handle => this.fetchProductCard(handle))
    );

    return results.map(r => r.status === 'fulfilled' ? r.value : false);
  }

  async fetchProductCard(handle) {
    try {
      const url = new URL(`${window.location.origin}/products/${handle}`);
      url.searchParams.set('view', 'card');

      const res = await fetch(url.toString());

      if (!res.ok) return false;

      const htmlText = await res.text();

      const doc = new DOMParser().parseFromString(htmlText, 'text/html');

      return doc.querySelector('color-swatch') || false;

    } catch (err) {
      console.error('Recently Viewed Error:', err);
      return false;
    }
  }

  appendCards(cards) {
    const fragment = document.createDocumentFragment();

    cards.forEach(card => {
      const slide = document.createElement('div');
      slide.setAttribute('data-swiper-slide', '');

      const wrapper = document.createElement('div');
      wrapper.className = 'wt-slider__card-wrapper';

      wrapper.appendChild(card);
      slide.appendChild(wrapper);

      fragment.appendChild(slide);
    });

    this.swiperContainer.appendChild(fragment);

    // Re-initialize the slider using the custom element logic
    const slideshowSection = this.section.querySelector('[data-recently-viewed] slideshow-section');
    if (slideshowSection && typeof slideshowSection.swiperInitilize === 'function') {
      slideshowSection.swiperInitilize();
    }
  }

  finalize() {
    if (this.swiperElement) {
      this.swiperElement.classList.remove('loading');
    }

    document.dispatchEvent(new CustomEvent('swiper:updated'));

    if (window.VariantSelector?.reinitialize) {
      window.VariantSelector.reinitialize(this.swiperContainer);
    }
  }
}

// Auto-init
document.addEventListener('DOMContentLoaded', () => {
    console.log('Initializing Recently Viewed Products');
  new RecentlyViewedProducts({
    productLimit: window.RECENTLY_VIEWED_LIMIT || 20,
  });
});